import React from 'react';
import PropTypes from 'prop-types';

import applySkeleton from '../../../../../hocs/applySkeleton';

const DetailsSubHeader = ({ text, theme }) => (
    <h4 className={ theme.detailsSubHeader }>
        {text}
    </h4>
);

DetailsSubHeader.propTypes = {
    theme: PropTypes.shape({}),
    text: PropTypes.string.isRequired,
};

export default applySkeleton(DetailsSubHeader);
